import { Objects } from "src/modules/utils/shared/objects";
import { Strings } from "src/modules/utils/shared/strings";

export class CssDebugger {

    private static allowedUnusedClasses = [
        'burger-menu', 
        'desktop-menu', 
        "p-inputwrapper", 
        "p-password-unmask-icon", 
        "p-button-icon-left", 
        'p-breadcrumb-home-item', 
        'p-avatar-label', 
        'p-inputwrapper-filled', 
        'p-multiselect-dropdown-icon', 
        'p-tabpanel-active', 
        'p-select-dropdown-icon', 
        'p-menuitem-link-active',
        'p-filled', 
        'p-anchored-overlay-leave-to',
        'p-anchored-overlay-enter-to',
        'p-panel-icons', 
        'p-panel-icons-end',
        "p-tag-label",
        "p-chip-label",
        "p-tree-selectable",
        "p-tree-node-toggle-icon",
        "p-toast-bottom-right",
        "p-dialog-mask",
        "p-hidden-focusable",
        "p-iconfield-left",
        "p-tree-empty-message",
        "p-tree-node-checkbox",
        "p-message-undefined",
        "p-element",
        "cdk-drop-list",
        "cdk-drag",
        "cdk-drag-disabled",
        "ace_print-margin-layer",
        "ace_open",
        "ace_lparen",
        "ace_rparen",
        "ace_escape",
        "sr-only",
        'null',
        "undefined"            
    ];

    private static flexProps = [
        'justify-content',
        'align-items',
        'align-content',
        'flex-direction',
        'flex-wrap',
        'gap',
        'row-gap',
        'column-gap'
    ];

    private static defaultFlexValues: any = {
        'flex-direction': 'row',
        'flex-wrap': 'nowrap',
        'justify-content': 'normal',
        'align-items': 'normal',
        'align-content': 'normal',
        'gap': '0px',
        'row-gap': '0px',
        'column-gap': '0px'
    };

    private static gridProps = [
        'grid-template-columns',
        'grid-template-rows',
        'grid-auto-flow',
        'grid-column',
        'grid-row'
    ];

    private static debugIdCounter = 0;


    debugElement(e: Element, rules: CSSRule[]): string[] {
        let result: string[] = [];

        if (e.closest('ngx-extended-pdf-viewer') != null) {
            return [];
        }

        let styleSheets = [...(document.styleSheets as unknown as any[])];
        
        for (let cls of e.classList) {
            if (cls.startsWith("ng-") || cls.startsWith("ngx-extended-pdf-viewer-") || cls.startsWith("ag-") ||CssDebugger.allowedUnusedClasses.includes(cls)) {
                continue;
            }
            if (styleSheets.some(sheet => [...sheet.cssRules || []].some(rule => rule.selectorText?.includes('.' + cls)))) {
                continue;
            }
            result.push("CSS-Klasse ohne Style: " + cls);
        }

        //IDEE WAR GUT, HAT ABER ZU VIELE PRAKTISCHE PROBLEME, 
        //Hier sollte herausgefunden werden, weile Flexbox-Attribute ungenutzt waren, weil gar kein Flexbox benutzt wurde
        /*
        let style = getComputedStyle(e);
        let display = style.display;

        if (!display.includes('flex') && display != "none") {
            for (let rule of rules as any[]) {
                if (!rule.selectorText ||!e.matches(rule.selectorText as string)) {
                    continue;
                }

                for (let prop of CssDebugger.flexProps) {
                    let value = rule.style.getPropertyValue(prop);

                    if (!value) continue;

                    result.push(
                            `[FLEX UNUSED] ${prop}=${value}`
                        );
                }
            }
        }
        */
        let debugId = this.ensureDebugId(e, result.length > 0);
    
        result = result.map(s => debugId + ": " + s);

        return result;
    }

    private ensureDebugId(e: Element, set: boolean): string {
        let attr = 'data-css-debug-id';

        if (set) {
            let existing = e.getAttribute(attr);
            if (existing != null) {
                return existing;
            }

            let id = 'cssdbg-' + Objects.toString(++CssDebugger.debugIdCounter).padStart(4, "0");
            e.setAttribute(attr, id);
            return id;
        }
        else {
            e.removeAttribute(attr);
            return null;
        }
}

    debug(): string[] {  
        let result: string[] = [];
        
        let elements = [...document.querySelectorAll('*')];

        let rules = [...document.styleSheets]
            .flatMap(sheet => {
                try {
                    return [...sheet.cssRules || []];
                } catch {
                    return []; // CORS
                }
            }).filter(rule => (rule as any).selectorText?.includes("."));

        for (let e of elements) {
            result = [...result, ...this.debugElement(e, rules)];
        }

        return result;
    }
    
}